module.exports = __webpack_public_path__ + "img/zizhi4.47d698df.png";